// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"307":"ee3a34fa","929":"37821f85","992":"705d8203"}[chunkId] + ".chunk.js";
};